import { render, staticRenderFns } from "./EditBannerForm.vue?vue&type=template&id=d264505e&"
import script from "./EditBannerForm.vue?vue&type=script&lang=js&"
export * from "./EditBannerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports